export enum STORAGE_KEYS {
  TOKEN = 'coco_token',
}
